// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div ng-bind=\"row.entity.InstallmentStartDate | date:'shortDate'\"></div>\n</div>\n";
// Exports
module.exports = code;